import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setScrolledActiveSection, setHashValueWithOffset } from '../../AmexMarketingUtils/AmexUtils';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexSecurityCenterProtectScams.scss';

const AmexSecurityCenterProtectScams = (
  {
    awsFolderName,
    baseRequestUrl,
    scamsConfig,
    dispatch,
    matchMedia,
    hash,
  }
) => {
  if (!scamsConfig) return null;

  const {
    id: sectionId,
    title = '',
    intro = '',
    icon,
    contents = '',
    max_number_of_contents: maxNumberOfContents = 6,
    min_number_of_contents: minNumberOfContents = 3,
  } = scamsConfig;

  let isMissing = false;
  const requiredKeys = ['id', 'title', 'icon', 'contents',
    'max_number_of_contents', 'min_number_of_contents'];

  requiredKeys.forEach((i) => {
    if (!(Object.prototype.hasOwnProperty.call(scamsConfig, i) && scamsConfig[i])) {
      isMissing = true;
    }
  });

  if (isMissing) return null;

  const requiredKeysContent = ['icon', 'content'];
  const validateContents = contents.slice()
    .filter((item) => requiredKeysContent.every((i) => Object.prototype.hasOwnProperty.call(item, i) && item[i]));

  let contentLeng = validateContents.length;
  if (contentLeng === 0 || contentLeng < minNumberOfContents) return null;
  if (contentLeng > maxNumberOfContents) { contentLeng = maxNumberOfContents; }

  const urlPrefix = `${baseRequestUrl}${awsFolderName}/images/`;
  const sectionIcon = `${urlPrefix}${icon}`;
  const isMobile = !matchMedia.md;
  setHashValueWithOffset(isMobile, 210, 210, sectionId, hash);
  const sections = useRef([]);

  const sanitizedTitle = sanitizeString(title);
  const sanitizedIntro = sanitizeString(intro);

  useEffect(() => {
    sections.current = document.querySelectorAll('[data-section]');
    window.addEventListener('scroll', () => { setScrolledActiveSection(sections, dispatch); });

    return () => {
      window.removeEventListener('scroll', () => { setScrolledActiveSection(sections, dispatch); });
    };
  }, []);

  const renderContentItems = contents?.slice(0, contentLeng).map((item) => {
    const sanitizedItemContent = sanitizeString(item?.content);
    return (
      <li
        className="AmexSecurityCenterProtectScams__contents--item"
      >
        <img
          className="AmexSecurityCenterProtectScams__contents--item__icon"
          src={`${urlPrefix}${item.icon}`}
          alt=""
        />
        <div
          className="AmexSecurityCenterProtectScams__contents--item__content"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizedItemContent,
          }}
        />
      </li>
    );
  });

  return (
    <section
      data-section
      id={`${sectionId}_section`}
      className="AmexSecurityCenterProtectScams"
    >
      <div className="container">
        <div className="AmexSecurityCenterProtectScams__wrapper">
          {sectionIcon && (
          <img
            className="AmexSecurityCenterProtectScams__icon"
            src={sectionIcon}
            alt=""
          />
          )}
          {title && (
            <h2
              id={sectionId}
              className="AmexSecurityCenterProtectScams__title"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: sanitizedTitle,
              }}
            />
          )}
          {intro && (
            <p
              className="AmexSecurityCenterProtectScams__intro"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: sanitizedIntro,
              }}
            />
          )}
          {contents && (
            <ul className="AmexSecurityCenterProtectScams__contents--list">
              {renderContentItems}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
};

AmexSecurityCenterProtectScams.propTypes = {
  awsFolderName: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  scamsConfig: PropTypes.shape({
    title: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    intro: PropTypes.string.isRequired,
    max_number_of_contents: PropTypes.number.isRequired,
    min_number_of_contents: PropTypes.number.isRequired,
    contents: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  hash: PropTypes.string.isRequired,
};

export { AmexSecurityCenterProtectScams as ComponentUnderTest };
export default connect()(AmexSecurityCenterProtectScams);
